import React from 'react';
import Tooltip from 'mrf/view/Tooltip';
import { StyledIcon } from 'mrf/styles/components/Icon.styles';

export default function TextIcon({
    iconColor,
    hoverColor,
    size = 5,
    icon: Icon,
    tooltip,
    ...props
}) {
    return (
        <Tooltip content={tooltip}>
            <StyledIcon iconColor={iconColor} hoverColor={hoverColor} size={size} {...props}>
                <Icon className='flex-grow' />
            </StyledIcon>
        </Tooltip>
    );
}
